<div class='dispatcher-contain'>
	<div *ngIf="dispatchers && dispatchers.length" class="dispatcher-list">
		<div class="autocomplete-wrapper dispatcher-autocomplete" [ngClass]="{'showCritical': !(selectedEntity && selectedEntity.value)}">
			<span class="toggle_id" [ngStyle]="{'opacity': !toggleChecked ? '1' : '0.35'}">Location</span>
			<mat-slide-toggle color="accent" (change)="toggleSelection($event)" (keydown.enter)="onToggleEnter($event)" [disabled]="false"
			  [checked]="toggleChecked" [aria-label]="'Toggle to either filter by location or dispatcher'">
				<span class="hidden-text">Select Location or Dispatcher with Toggle</span>
			</mat-slide-toggle>
			<span class="toggle_id" [ngStyle]="{'opacity': toggleChecked ? '1' : '0.35'}">Dispatcher</span>
			<zui-searchable-dropdown
					label="{{currentToggleType === 'dispatcherId' ? 'DISPATCHER*': 'LOCATION*'}}"
					[attr.aria-label]="currentToggleType === 'dispatcherId' ? 'Enter Dispatcher Name': 'Enter Location Name'"
					placeholder="{{currentToggleType === 'dispatcherId' ? 'Enter Dispatcher Name': 'Enter Location Name'}}"
					[options]="filteredResults"
					[z_formGroup]="dispatcherLocationFormGroup"
					[isMultiple]="false"
					[selectOptionsControlName]="'listedValue'"
					[searchFormControlName]="'dispatcherLocationId'"
					classIdentifier="dropdown-select-panel"
			></zui-searchable-dropdown>
		</div>
	</div>
</div>
